<template>
  <div class="why-patex-campus bg--color-01">
    <div class="container-wrapper bg--color-10">
      <div class="why-patex-campus__container container-new">
        <div class="why-patex-campus__image-block">
          <img
            class="why-patex-campus__image"
            width="100%"
            src="@/assets/img/crypto-campus/why-patex-campus/image.svg"
            alt="laptop image"
          >
        </div>
        <div class="why-patex-campus__info">
          <h3 class="txt--color-04 txt--36px txt--44px--l txt--bold txt--height-44px txt--height-58px--l mb-24">
            {{ $t('cryptoCampus.whyPatexCampus.title') }}
          </h3>
          <p
            class="txt--color-04 txt--16px txt--22px txt--weight-400 txt--height-20px txt--height-30px mb-24"
            v-html="$t('cryptoCampus.whyPatexCampus.desc')"
          />
          <button-with-arrow
            href="https://campus.patex.io/"
            target="__blank"
            class="why-patex-campus__btn"
          >
            {{ $t('cryptoCampus.whyPatexCampus.btn') }}
          </button-with-arrow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyPatexCampus',
  components: {
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
.why-patex-campus {
  &__container {
    display: grid;
    gap: toRem(28px);

    @include bp(m) {
      grid-template-columns: 1.5fr 2.5fr;
      gap: toRem(100px);
    }

    @include bp(l) {
      gap: toRem(160px);
    }
  }

  &__btn {
    @include bp(m) {
      width: fit-content;
    }
  }

  &__image-block {
    display: flex;
    justify-content: center;
  }

  &__image {
    max-width: 289px;

    @include bp(l) {
      max-width: 373px;
    }
  }
}
</style>
